module.exports = __webpack_public_path__ + "static/media/raceday-1.0c020b49.png";